import { render } from "./EdmAddNewSenderDialog.vue?vue&type=template&id=6f23ba12"
import script from "./EdmAddNewSenderDialog.vue?vue&type=script&lang=js"
export * from "./EdmAddNewSenderDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__